module.exports = __webpack_public_path__ + "img/icon-phone.19b9c3f3.svg";